import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { getSavedCarts } from "../../../services/cartPersistence";
const Footer = ({ cartTotal, alertUnreadTotal }) => {
  const { pathname } = useLocation();

  const isActive = (paths) =>
    paths.some((p) => pathname === p || pathname.startsWith(p + "/"));

  return (
    <div style={{ backgroundColor: "#fff" }} className="d-flex justify-content-center">
      <div
        className={`content pt-10 font-size-xs clearfix ${
          localStorage.getItem("footerStyleType") === "FLOAT"
            ? "footer-float"
            : "footer-fixed"
        }`}
      >
        {/* Near me */}
        <NavLink to="/" className="col footer-links px-2 py-1">
          <i
            className={`si si-pointer fa-2x ${
              isActive(["/"]) ? "active-footer-tab" : ""
            }`}
          />
          <br />
          <span className={isActive(["/"]) ? "active-footer-tab" : ""}>
            {localStorage.getItem("footerNearme")}
          </span>
        </NavLink>

        {/* Alerts */}
        <NavLink to="/alerts" className="col footer-links px-2 py-1">
          {alertUnreadTotal > 0 && (
            <span
              className="cart-quantity-badge"
              style={{ backgroundColor: localStorage.getItem("storeColor") }}
            >
              {alertUnreadTotal}
            </span>
          )}
          <i
            className={`si si-bell fa-2x ${
              isActive(["/alerts"]) ? "active-footer-tab" : ""
            }`}
          />
          <br />
          <span className={isActive(["/alerts"]) ? "active-footer-tab" : ""}>
            {localStorage.getItem("footerAlerts")}
          </span>
        </NavLink>

        {/* Explore */}
        <NavLink to="/explore" className="col footer-links px-2 py-1">
          <i
            className={`si si-magnifier fa-2x ${
              isActive(["/explore"]) ? "active-footer-tab" : ""
            }`}
          />
          <br />
          <span className={isActive(["/explore"]) ? "active-footer-tab" : ""}>
            {localStorage.getItem("footerExplore")}
          </span>
        </NavLink>

        {/* Cart */}
        <NavLink to="/my-carts" className="col footer-links px-2 py-1">
          <i
            className={`si si-basket fa-2x ${
              isActive(["/my-carts", "/cart"]) ? "active-footer-tab" : ""
            }`}
          />
          <br />
          <span className={isActive(["/my-carts", "/cart"]) ? "active-footer-tab" : ""}>
            {localStorage.getItem("footerCart")}
          </span>

          {(() => {
            const count = Object.keys(getSavedCarts()).length;
            return count > 0 ? (
              <span
                className="cart-quantity-badge"
                style={{ backgroundColor: localStorage.getItem("storeColor") }}
              >
                {count}
              </span>
            ) : null;
          })()}
        </NavLink>

        {/* Account */}
        <NavLink to="/my-account" className="col footer-links px-2 py-1">
          <i
            className={`si si-user fa-2x ${
              isActive(["/my-account"]) ? "active-footer-tab" : ""
            }`}
          />
          <br />
          <span
            className={isActive(["/my-account"]) ? "active-footer-tab" : ""}
          >
            {localStorage.getItem("footerAccount")}
          </span>
        </NavLink>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  cartTotal: state.total.data,
  alertUnreadTotal: state.alert.alertUnreadTotal,
});

export default (connect(
  mapStateToProps,
  {}
)(Footer));
